<template>
    <div>
        <youtube :video-id="video" :player-vars="{ rel: 0 }" ref="youtube" @playing="playing" :resize="true"></youtube>
    </div>
</template>
<script>
export default {
    props: {
        video: {
            type: String
        }
    },
    data() {
        return {};
    },
    mounted() {
        //  console.log("this.video", this.video);
    },
    methods: {
        playVideo() {
            this.player.playVideo();
        },
        playing() {
        }
    },
    computed: {
        player() {
            return this.$refs.youtube.player;
        }
    }
};
</script>
<style scoped>
iframe {
  width: 100%;
  max-width: 650px; /* Also helpful. Optional. */
}
</style>
